module.exports = __webpack_public_path__ + "static/media/35941070304_e16e779e7f_k.34fc7b2a.jpg";